// utils/api-dim-measurements.js
import { supabase } from './supabase';
import { stdUncFromResolution, combinedStdUnc, expandedUncertainty } from './metrology';

// helpers
const mean = xs => {
  const arr = xs.filter(v => v !== '' && v != null).map(Number);
  if (!arr.length) return null;
  return arr.reduce((a,b)=>a+b,0)/arr.length;
};
const stdev = xs => {
  const arr = xs.filter(v => v !== '' && v != null).map(Number);
  const n = arr.length;
  if (n < 2) return null;
  const m = mean(arr);
  const v = arr.reduce((s, x) => s + (x - m) ** 2, 0) / (n - 1);
  return Math.sqrt(v);
};

// Inserta muchas filas, calculando media y repetibilidad (std)
export async function saveDimensionalRows({ calibrationId, unit, rows, resolution, k = 2 }) {
  const payload = rows
    .filter(r => r?.setpoint !== '' && r?.setpoint != null)
    .map(r => {
      const reps = ['r1','r2','r3','r4'].map(k => r[k]).filter(v => v !== '' && v != null);
      const m = mean(reps);
      const s = stdev(reps);
      const u_res = stdUncFromResolution(Number(resolution || 0)); // digital rectangular
      const u_c = combinedStdUnc({
        refStd: 0,
        repeatabilityStd: Number(s || 0),
        resStd: u_res,
        driftStd: 0,
        otherStd: 0
      });
      const U = expandedUncertainty(u_c, k);

      return {
        calibration_id: calibrationId,
        setpoint: Number(r.setpoint),
        reading: m != null ? Number(m) : null,
        unit,
        ref_std_unc: 0,
        repeatability_std: s != null ? Number(s) : null,
        resolution: Number(resolution || 0),
        drift_std: 0,
        other_std: 0,
        coverage_k: k,
        // NOTA: los campos derivados (error, U) los recalcula frontend cuando lee (igual que haces hoy)
      };
    });

  if (!payload.length) return [];

  const { data, error } = await supabase
    .from('measurements')
    .insert(payload)
    .select('id, setpoint, reading, unit');
  if (error) throw error;
  return data;
}
